module.exports = __webpack_public_path__ + "img/2_48.dc519679.png";